import { cn } from "@shared/lib/utils";
import { Button } from "@shared/ui/button";
import {
  Calendar,
  CheckCircle,
  Download,
  Edit,
  Eye,
  Printer,
  RefreshCw,
  UserCheck,
} from "lucide-react";

type ActionType =
  | "edit"
  | "mark-started"
  | "mark-completed"
  | "print"
  | "view"
  | "retry"
  | "download"
  | "edit-date"
  | "accept"; // Added new action type for accepting cycles

interface ActionButtonProps {
  type: ActionType;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  iconOnly?: boolean;
}

const actionConfig = {
  edit: {
    icon: Edit,
    label: "Edit",
    variant: "outline" as const,
  },
  "mark-started": {
    icon: CheckCircle,
    label: "Mark Started",
    variant: "outline" as const,
  },
  "mark-completed": {
    icon: CheckCircle,
    label: "Mark Completed",
    variant: "outline" as const,
  },
  print: {
    icon: Printer,
    label: "Print",
    variant: "outline" as const,
  },
  view: {
    icon: Eye,
    label: "View",
    variant: "outline" as const,
  },
  retry: {
    icon: RefreshCw,
    label: "Retry",
    variant: "outline" as const,
  },
  download: {
    icon: Download,
    label: "Download",
    variant: "outline" as const,
  },
  "edit-date": {
    icon: Calendar,
    label: "Edit Date",
    variant: "outline" as const,
  },
  accept: {
    // Added configuration for accept action
    icon: UserCheck,
    label: "Accept Cycle",
    variant: "outline" as const,
  },
};

export function ActionButton({
  type,
  onClick,
  disabled,
  className,
  iconOnly = false,
}: ActionButtonProps) {
  const config = actionConfig[type];
  const Icon = config.icon;

  return (
    <Button
      variant={config.variant}
      size={iconOnly ? "icon" : "sm"}
      onClick={onClick}
      disabled={disabled}
      className={cn(iconOnly ? "h-8 w-8" : "gap-1", className)}
      title={config.label}
    >
      <Icon className="w-4 h-4" />
      {!iconOnly && <span className="hidden sm:inline">{config.label}</span>}
    </Button>
  );
}
